import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModule, SidebarModule, TooltipModule } from 'primeng/primeng';
import { AppHeaderComponent } from './app-header.component';
import { AppLeftNavModule } from '../app-left-nav/app-left-nav.module';

@NgModule({
  imports: [ CommonModule, MenuModule, SidebarModule, AppLeftNavModule, TooltipModule ],
  declarations: [ AppHeaderComponent ],
  exports: [ AppHeaderComponent ]
})

export class AppHeaderModule { }
